// Generated by bin/generate-sport-artwork-maps.mjs from docs/design/lift-sports/prompts.json.
// URL assets avoid retaining unused Next.js image metadata and inline blur placeholders.
import type { SportArtworkResources } from './sport-artwork-types';
const artwork0_64 = new URL('../../assets/sports/lift/64/padel.webp', import.meta.url).href;
const artwork0_128 = new URL('../../assets/sports/lift/128/padel.webp', import.meta.url).href;
const artwork0_256 = new URL('../../assets/sports/lift/256/padel.webp', import.meta.url).href;
const artwork0_512 = new URL('../../assets/sports/lift/512/padel.webp', import.meta.url).href;
const artwork1_64 = new URL('../../assets/sports/lift/64/tennis.webp', import.meta.url).href;
const artwork1_128 = new URL('../../assets/sports/lift/128/tennis.webp', import.meta.url).href;
const artwork1_256 = new URL('../../assets/sports/lift/256/tennis.webp', import.meta.url).href;
const artwork1_512 = new URL('../../assets/sports/lift/512/tennis.webp', import.meta.url).href;
const artwork2_64 = new URL('../../assets/sports/lift/64/squash.webp', import.meta.url).href;
const artwork2_128 = new URL('../../assets/sports/lift/128/squash.webp', import.meta.url).href;
const artwork2_256 = new URL('../../assets/sports/lift/256/squash.webp', import.meta.url).href;
const artwork2_512 = new URL('../../assets/sports/lift/512/squash.webp', import.meta.url).href;
const artwork3_64 = new URL('../../assets/sports/lift/64/badminton.webp', import.meta.url).href;
const artwork3_128 = new URL('../../assets/sports/lift/128/badminton.webp', import.meta.url).href;
const artwork3_256 = new URL('../../assets/sports/lift/256/badminton.webp', import.meta.url).href;
const artwork3_512 = new URL('../../assets/sports/lift/512/badminton.webp', import.meta.url).href;
const artwork4_64 = new URL('../../assets/sports/lift/64/pickleball.webp', import.meta.url).href;
const artwork4_128 = new URL('../../assets/sports/lift/128/pickleball.webp', import.meta.url).href;
const artwork4_256 = new URL('../../assets/sports/lift/256/pickleball.webp', import.meta.url).href;
const artwork4_512 = new URL('../../assets/sports/lift/512/pickleball.webp', import.meta.url).href;
const artwork5_64 = new URL('../../assets/sports/lift/64/table-tennis.webp', import.meta.url).href;
const artwork5_128 = new URL('../../assets/sports/lift/128/table-tennis.webp', import.meta.url)
  .href;
const artwork5_256 = new URL('../../assets/sports/lift/256/table-tennis.webp', import.meta.url)
  .href;
const artwork5_512 = new URL('../../assets/sports/lift/512/table-tennis.webp', import.meta.url)
  .href;
const artwork6_64 = new URL('../../assets/sports/lift/64/football.webp', import.meta.url).href;
const artwork6_128 = new URL('../../assets/sports/lift/128/football.webp', import.meta.url).href;
const artwork6_256 = new URL('../../assets/sports/lift/256/football.webp', import.meta.url).href;
const artwork6_512 = new URL('../../assets/sports/lift/512/football.webp', import.meta.url).href;
const artwork7_64 = new URL('../../assets/sports/lift/64/basketball.webp', import.meta.url).href;
const artwork7_128 = new URL('../../assets/sports/lift/128/basketball.webp', import.meta.url).href;
const artwork7_256 = new URL('../../assets/sports/lift/256/basketball.webp', import.meta.url).href;
const artwork7_512 = new URL('../../assets/sports/lift/512/basketball.webp', import.meta.url).href;
const artwork8_64 = new URL('../../assets/sports/lift/64/volleyball.webp', import.meta.url).href;
const artwork8_128 = new URL('../../assets/sports/lift/128/volleyball.webp', import.meta.url).href;
const artwork8_256 = new URL('../../assets/sports/lift/256/volleyball.webp', import.meta.url).href;
const artwork8_512 = new URL('../../assets/sports/lift/512/volleyball.webp', import.meta.url).href;
const artwork9_64 = new URL('../../assets/sports/lift/64/handball.webp', import.meta.url).href;
const artwork9_128 = new URL('../../assets/sports/lift/128/handball.webp', import.meta.url).href;
const artwork9_256 = new URL('../../assets/sports/lift/256/handball.webp', import.meta.url).href;
const artwork9_512 = new URL('../../assets/sports/lift/512/handball.webp', import.meta.url).href;
const artwork10_64 = new URL('../../assets/sports/lift/64/rugby.webp', import.meta.url).href;
const artwork10_128 = new URL('../../assets/sports/lift/128/rugby.webp', import.meta.url).href;
const artwork10_256 = new URL('../../assets/sports/lift/256/rugby.webp', import.meta.url).href;
const artwork10_512 = new URL('../../assets/sports/lift/512/rugby.webp', import.meta.url).href;
const artwork11_64 = new URL('../../assets/sports/lift/64/water-polo.webp', import.meta.url).href;
const artwork11_128 = new URL('../../assets/sports/lift/128/water-polo.webp', import.meta.url).href;
const artwork11_256 = new URL('../../assets/sports/lift/256/water-polo.webp', import.meta.url).href;
const artwork11_512 = new URL('../../assets/sports/lift/512/water-polo.webp', import.meta.url).href;
const artwork12_64 = new URL('../../assets/sports/lift/64/taekwondo.webp', import.meta.url).href;
const artwork12_128 = new URL('../../assets/sports/lift/128/taekwondo.webp', import.meta.url).href;
const artwork12_256 = new URL('../../assets/sports/lift/256/taekwondo.webp', import.meta.url).href;
const artwork12_512 = new URL('../../assets/sports/lift/512/taekwondo.webp', import.meta.url).href;
const artwork13_64 = new URL('../../assets/sports/lift/64/karate.webp', import.meta.url).href;
const artwork13_128 = new URL('../../assets/sports/lift/128/karate.webp', import.meta.url).href;
const artwork13_256 = new URL('../../assets/sports/lift/256/karate.webp', import.meta.url).href;
const artwork13_512 = new URL('../../assets/sports/lift/512/karate.webp', import.meta.url).href;
const artwork14_64 = new URL('../../assets/sports/lift/64/judo.webp', import.meta.url).href;
const artwork14_128 = new URL('../../assets/sports/lift/128/judo.webp', import.meta.url).href;
const artwork14_256 = new URL('../../assets/sports/lift/256/judo.webp', import.meta.url).href;
const artwork14_512 = new URL('../../assets/sports/lift/512/judo.webp', import.meta.url).href;
const artwork15_64 = new URL('../../assets/sports/lift/64/bjj.webp', import.meta.url).href;
const artwork15_128 = new URL('../../assets/sports/lift/128/bjj.webp', import.meta.url).href;
const artwork15_256 = new URL('../../assets/sports/lift/256/bjj.webp', import.meta.url).href;
const artwork15_512 = new URL('../../assets/sports/lift/512/bjj.webp', import.meta.url).href;
const artwork16_64 = new URL('../../assets/sports/lift/64/kickboxing.webp', import.meta.url).href;
const artwork16_128 = new URL('../../assets/sports/lift/128/kickboxing.webp', import.meta.url).href;
const artwork16_256 = new URL('../../assets/sports/lift/256/kickboxing.webp', import.meta.url).href;
const artwork16_512 = new URL('../../assets/sports/lift/512/kickboxing.webp', import.meta.url).href;
const artwork17_64 = new URL('../../assets/sports/lift/64/muay-thai.webp', import.meta.url).href;
const artwork17_128 = new URL('../../assets/sports/lift/128/muay-thai.webp', import.meta.url).href;
const artwork17_256 = new URL('../../assets/sports/lift/256/muay-thai.webp', import.meta.url).href;
const artwork17_512 = new URL('../../assets/sports/lift/512/muay-thai.webp', import.meta.url).href;
const artwork18_64 = new URL('../../assets/sports/lift/64/boxing.webp', import.meta.url).href;
const artwork18_128 = new URL('../../assets/sports/lift/128/boxing.webp', import.meta.url).href;
const artwork18_256 = new URL('../../assets/sports/lift/256/boxing.webp', import.meta.url).href;
const artwork18_512 = new URL('../../assets/sports/lift/512/boxing.webp', import.meta.url).href;
const artwork19_64 = new URL('../../assets/sports/lift/64/mma.webp', import.meta.url).href;
const artwork19_128 = new URL('../../assets/sports/lift/128/mma.webp', import.meta.url).href;
const artwork19_256 = new URL('../../assets/sports/lift/256/mma.webp', import.meta.url).href;
const artwork19_512 = new URL('../../assets/sports/lift/512/mma.webp', import.meta.url).href;
const artwork20_64 = new URL('../../assets/sports/lift/64/swimming.webp', import.meta.url).href;
const artwork20_128 = new URL('../../assets/sports/lift/128/swimming.webp', import.meta.url).href;
const artwork20_256 = new URL('../../assets/sports/lift/256/swimming.webp', import.meta.url).href;
const artwork20_512 = new URL('../../assets/sports/lift/512/swimming.webp', import.meta.url).href;
const artwork21_64 = new URL('../../assets/sports/lift/64/jet-ski.webp', import.meta.url).href;
const artwork21_128 = new URL('../../assets/sports/lift/128/jet-ski.webp', import.meta.url).href;
const artwork21_256 = new URL('../../assets/sports/lift/256/jet-ski.webp', import.meta.url).href;
const artwork21_512 = new URL('../../assets/sports/lift/512/jet-ski.webp', import.meta.url).href;
const artwork22_64 = new URL('../../assets/sports/lift/64/kayak.webp', import.meta.url).href;
const artwork22_128 = new URL('../../assets/sports/lift/128/kayak.webp', import.meta.url).href;
const artwork22_256 = new URL('../../assets/sports/lift/256/kayak.webp', import.meta.url).href;
const artwork22_512 = new URL('../../assets/sports/lift/512/kayak.webp', import.meta.url).href;
const artwork23_64 = new URL('../../assets/sports/lift/64/gym.webp', import.meta.url).href;
const artwork23_128 = new URL('../../assets/sports/lift/128/gym.webp', import.meta.url).href;
const artwork23_256 = new URL('../../assets/sports/lift/256/gym.webp', import.meta.url).href;
const artwork23_512 = new URL('../../assets/sports/lift/512/gym.webp', import.meta.url).href;
const artwork24_64 = new URL('../../assets/sports/lift/64/crossfit.webp', import.meta.url).href;
const artwork24_128 = new URL('../../assets/sports/lift/128/crossfit.webp', import.meta.url).href;
const artwork24_256 = new URL('../../assets/sports/lift/256/crossfit.webp', import.meta.url).href;
const artwork24_512 = new URL('../../assets/sports/lift/512/crossfit.webp', import.meta.url).href;
const artwork25_64 = new URL('../../assets/sports/lift/64/yoga.webp', import.meta.url).href;
const artwork25_128 = new URL('../../assets/sports/lift/128/yoga.webp', import.meta.url).href;
const artwork25_256 = new URL('../../assets/sports/lift/256/yoga.webp', import.meta.url).href;
const artwork25_512 = new URL('../../assets/sports/lift/512/yoga.webp', import.meta.url).href;
const artwork26_64 = new URL('../../assets/sports/lift/64/pilates.webp', import.meta.url).href;
const artwork26_128 = new URL('../../assets/sports/lift/128/pilates.webp', import.meta.url).href;
const artwork26_256 = new URL('../../assets/sports/lift/256/pilates.webp', import.meta.url).href;
const artwork26_512 = new URL('../../assets/sports/lift/512/pilates.webp', import.meta.url).href;
const artwork27_64 = new URL('../../assets/sports/lift/64/dance.webp', import.meta.url).href;
const artwork27_128 = new URL('../../assets/sports/lift/128/dance.webp', import.meta.url).href;
const artwork27_256 = new URL('../../assets/sports/lift/256/dance.webp', import.meta.url).href;
const artwork27_512 = new URL('../../assets/sports/lift/512/dance.webp', import.meta.url).href;
const artwork28_64 = new URL('../../assets/sports/lift/64/cycling.webp', import.meta.url).href;
const artwork28_128 = new URL('../../assets/sports/lift/128/cycling.webp', import.meta.url).href;
const artwork28_256 = new URL('../../assets/sports/lift/256/cycling.webp', import.meta.url).href;
const artwork28_512 = new URL('../../assets/sports/lift/512/cycling.webp', import.meta.url).href;
const artwork29_64 = new URL('../../assets/sports/lift/64/running.webp', import.meta.url).href;
const artwork29_128 = new URL('../../assets/sports/lift/128/running.webp', import.meta.url).href;
const artwork29_256 = new URL('../../assets/sports/lift/256/running.webp', import.meta.url).href;
const artwork29_512 = new URL('../../assets/sports/lift/512/running.webp', import.meta.url).href;
const artwork30_64 = new URL('../../assets/sports/lift/64/hiking.webp', import.meta.url).href;
const artwork30_128 = new URL('../../assets/sports/lift/128/hiking.webp', import.meta.url).href;
const artwork30_256 = new URL('../../assets/sports/lift/256/hiking.webp', import.meta.url).href;
const artwork30_512 = new URL('../../assets/sports/lift/512/hiking.webp', import.meta.url).href;
const artwork31_64 = new URL('../../assets/sports/lift/64/climbing.webp', import.meta.url).href;
const artwork31_128 = new URL('../../assets/sports/lift/128/climbing.webp', import.meta.url).href;
const artwork31_256 = new URL('../../assets/sports/lift/256/climbing.webp', import.meta.url).href;
const artwork31_512 = new URL('../../assets/sports/lift/512/climbing.webp', import.meta.url).href;
const artwork32_64 = new URL('../../assets/sports/lift/64/skiing.webp', import.meta.url).href;
const artwork32_128 = new URL('../../assets/sports/lift/128/skiing.webp', import.meta.url).href;
const artwork32_256 = new URL('../../assets/sports/lift/256/skiing.webp', import.meta.url).href;
const artwork32_512 = new URL('../../assets/sports/lift/512/skiing.webp', import.meta.url).href;
const artwork33_64 = new URL('../../assets/sports/lift/64/bowling.webp', import.meta.url).href;
const artwork33_128 = new URL('../../assets/sports/lift/128/bowling.webp', import.meta.url).href;
const artwork33_256 = new URL('../../assets/sports/lift/256/bowling.webp', import.meta.url).href;
const artwork33_512 = new URL('../../assets/sports/lift/512/bowling.webp', import.meta.url).href;
const artwork34_64 = new URL('../../assets/sports/lift/64/billiards.webp', import.meta.url).href;
const artwork34_128 = new URL('../../assets/sports/lift/128/billiards.webp', import.meta.url).href;
const artwork34_256 = new URL('../../assets/sports/lift/256/billiards.webp', import.meta.url).href;
const artwork34_512 = new URL('../../assets/sports/lift/512/billiards.webp', import.meta.url).href;
const artwork35_64 = new URL('../../assets/sports/lift/64/golf.webp', import.meta.url).href;
const artwork35_128 = new URL('../../assets/sports/lift/128/golf.webp', import.meta.url).href;
const artwork35_256 = new URL('../../assets/sports/lift/256/golf.webp', import.meta.url).href;
const artwork35_512 = new URL('../../assets/sports/lift/512/golf.webp', import.meta.url).href;
const artwork36_64 = new URL('../../assets/sports/lift/64/equestrian.webp', import.meta.url).href;
const artwork36_128 = new URL('../../assets/sports/lift/128/equestrian.webp', import.meta.url).href;
const artwork36_256 = new URL('../../assets/sports/lift/256/equestrian.webp', import.meta.url).href;
const artwork36_512 = new URL('../../assets/sports/lift/512/equestrian.webp', import.meta.url).href;
const artwork37_64 = new URL('../../assets/sports/lift/64/archery.webp', import.meta.url).href;
const artwork37_128 = new URL('../../assets/sports/lift/128/archery.webp', import.meta.url).href;
const artwork37_256 = new URL('../../assets/sports/lift/256/archery.webp', import.meta.url).href;
const artwork37_512 = new URL('../../assets/sports/lift/512/archery.webp', import.meta.url).href;
const artwork38_64 = new URL('../../assets/sports/lift/64/shooting.webp', import.meta.url).href;
const artwork38_128 = new URL('../../assets/sports/lift/128/shooting.webp', import.meta.url).href;
const artwork38_256 = new URL('../../assets/sports/lift/256/shooting.webp', import.meta.url).href;
const artwork38_512 = new URL('../../assets/sports/lift/512/shooting.webp', import.meta.url).href;
const artwork39_64 = new URL('../../assets/sports/lift/64/futsal.webp', import.meta.url).href;
const artwork39_128 = new URL('../../assets/sports/lift/128/futsal.webp', import.meta.url).href;
const artwork39_256 = new URL('../../assets/sports/lift/256/futsal.webp', import.meta.url).href;
const artwork39_512 = new URL('../../assets/sports/lift/512/futsal.webp', import.meta.url).href;
const artwork40_64 = new URL('../../assets/sports/lift/64/motocross.webp', import.meta.url).href;
const artwork40_128 = new URL('../../assets/sports/lift/128/motocross.webp', import.meta.url).href;
const artwork40_256 = new URL('../../assets/sports/lift/256/motocross.webp', import.meta.url).href;
const artwork40_512 = new URL('../../assets/sports/lift/512/motocross.webp', import.meta.url).href;
const artwork41_64 = new URL('../../assets/sports/lift/64/paragliding.webp', import.meta.url).href;
const artwork41_128 = new URL('../../assets/sports/lift/128/paragliding.webp', import.meta.url)
  .href;
const artwork41_256 = new URL('../../assets/sports/lift/256/paragliding.webp', import.meta.url)
  .href;
const artwork41_512 = new URL('../../assets/sports/lift/512/paragliding.webp', import.meta.url)
  .href;
const artwork42_64 = new URL('../../assets/sports/lift/64/karting.webp', import.meta.url).href;
const artwork42_128 = new URL('../../assets/sports/lift/128/karting.webp', import.meta.url).href;
const artwork42_256 = new URL('../../assets/sports/lift/256/karting.webp', import.meta.url).href;
const artwork42_512 = new URL('../../assets/sports/lift/512/karting.webp', import.meta.url).href;
const artwork43_64 = new URL('../../assets/sports/lift/64/paintball.webp', import.meta.url).href;
const artwork43_128 = new URL('../../assets/sports/lift/128/paintball.webp', import.meta.url).href;
const artwork43_256 = new URL('../../assets/sports/lift/256/paintball.webp', import.meta.url).href;
const artwork43_512 = new URL('../../assets/sports/lift/512/paintball.webp', import.meta.url).href;
const artwork44_64 = new URL('../../assets/sports/lift/64/airsoft.webp', import.meta.url).href;
const artwork44_128 = new URL('../../assets/sports/lift/128/airsoft.webp', import.meta.url).href;
const artwork44_256 = new URL('../../assets/sports/lift/256/airsoft.webp', import.meta.url).href;
const artwork44_512 = new URL('../../assets/sports/lift/512/airsoft.webp', import.meta.url).href;
const artwork45_64 = new URL('../../assets/sports/lift/64/scuba-diving.webp', import.meta.url).href;
const artwork45_128 = new URL('../../assets/sports/lift/128/scuba-diving.webp', import.meta.url)
  .href;
const artwork45_256 = new URL('../../assets/sports/lift/256/scuba-diving.webp', import.meta.url)
  .href;
const artwork45_512 = new URL('../../assets/sports/lift/512/scuba-diving.webp', import.meta.url)
  .href;
const artwork46_64 = new URL('../../assets/sports/lift/64/surfing.webp', import.meta.url).href;
const artwork46_128 = new URL('../../assets/sports/lift/128/surfing.webp', import.meta.url).href;
const artwork46_256 = new URL('../../assets/sports/lift/256/surfing.webp', import.meta.url).href;
const artwork46_512 = new URL('../../assets/sports/lift/512/surfing.webp', import.meta.url).href;
const artwork47_64 = new URL('../../assets/sports/lift/64/kitesurfing.webp', import.meta.url).href;
const artwork47_128 = new URL('../../assets/sports/lift/128/kitesurfing.webp', import.meta.url)
  .href;
const artwork47_256 = new URL('../../assets/sports/lift/256/kitesurfing.webp', import.meta.url)
  .href;
const artwork47_512 = new URL('../../assets/sports/lift/512/kitesurfing.webp', import.meta.url)
  .href;
const artwork48_64 = new URL('../../assets/sports/lift/64/windsurfing.webp', import.meta.url).href;
const artwork48_128 = new URL('../../assets/sports/lift/128/windsurfing.webp', import.meta.url)
  .href;
const artwork48_256 = new URL('../../assets/sports/lift/256/windsurfing.webp', import.meta.url)
  .href;
const artwork48_512 = new URL('../../assets/sports/lift/512/windsurfing.webp', import.meta.url)
  .href;
const artwork49_64 = new URL('../../assets/sports/lift/64/wakeboarding.webp', import.meta.url).href;
const artwork49_128 = new URL('../../assets/sports/lift/128/wakeboarding.webp', import.meta.url)
  .href;
const artwork49_256 = new URL('../../assets/sports/lift/256/wakeboarding.webp', import.meta.url)
  .href;
const artwork49_512 = new URL('../../assets/sports/lift/512/wakeboarding.webp', import.meta.url)
  .href;
const artwork50_64 = new URL('../../assets/sports/lift/64/rafting.webp', import.meta.url).href;
const artwork50_128 = new URL('../../assets/sports/lift/128/rafting.webp', import.meta.url).href;
const artwork50_256 = new URL('../../assets/sports/lift/256/rafting.webp', import.meta.url).href;
const artwork50_512 = new URL('../../assets/sports/lift/512/rafting.webp', import.meta.url).href;
const artwork51_64 = new URL('../../assets/sports/lift/64/horse-racing.webp', import.meta.url).href;
const artwork51_128 = new URL('../../assets/sports/lift/128/horse-racing.webp', import.meta.url)
  .href;
const artwork51_256 = new URL('../../assets/sports/lift/256/horse-racing.webp', import.meta.url)
  .href;
const artwork51_512 = new URL('../../assets/sports/lift/512/horse-racing.webp', import.meta.url)
  .href;
const artwork52_64 = new URL('../../assets/sports/lift/64/gymnastics.webp', import.meta.url).href;
const artwork52_128 = new URL('../../assets/sports/lift/128/gymnastics.webp', import.meta.url).href;
const artwork52_256 = new URL('../../assets/sports/lift/256/gymnastics.webp', import.meta.url).href;
const artwork52_512 = new URL('../../assets/sports/lift/512/gymnastics.webp', import.meta.url).href;
const artwork53_64 = new URL('../../assets/sports/lift/64/fencing.webp', import.meta.url).href;
const artwork53_128 = new URL('../../assets/sports/lift/128/fencing.webp', import.meta.url).href;
const artwork53_256 = new URL('../../assets/sports/lift/256/fencing.webp', import.meta.url).href;
const artwork53_512 = new URL('../../assets/sports/lift/512/fencing.webp', import.meta.url).href;
const artwork54_64 = new URL('../../assets/sports/lift/64/ice-skating.webp', import.meta.url).href;
const artwork54_128 = new URL('../../assets/sports/lift/128/ice-skating.webp', import.meta.url)
  .href;
const artwork54_256 = new URL('../../assets/sports/lift/256/ice-skating.webp', import.meta.url)
  .href;
const artwork54_512 = new URL('../../assets/sports/lift/512/ice-skating.webp', import.meta.url)
  .href;
const artwork55_64 = new URL('../../assets/sports/lift/64/skateboarding.webp', import.meta.url)
  .href;
const artwork55_128 = new URL('../../assets/sports/lift/128/skateboarding.webp', import.meta.url)
  .href;
const artwork55_256 = new URL('../../assets/sports/lift/256/skateboarding.webp', import.meta.url)
  .href;
const artwork55_512 = new URL('../../assets/sports/lift/512/skateboarding.webp', import.meta.url)
  .href;
const artwork56_64 = new URL('../../assets/sports/lift/64/parkour.webp', import.meta.url).href;
const artwork56_128 = new URL('../../assets/sports/lift/128/parkour.webp', import.meta.url).href;
const artwork56_256 = new URL('../../assets/sports/lift/256/parkour.webp', import.meta.url).href;
const artwork56_512 = new URL('../../assets/sports/lift/512/parkour.webp', import.meta.url).href;
const artwork57_64 = new URL('../../assets/sports/lift/64/petanque.webp', import.meta.url).href;
const artwork57_128 = new URL('../../assets/sports/lift/128/petanque.webp', import.meta.url).href;
const artwork57_256 = new URL('../../assets/sports/lift/256/petanque.webp', import.meta.url).href;
const artwork57_512 = new URL('../../assets/sports/lift/512/petanque.webp', import.meta.url).href;
const artwork58_64 = new URL('../../assets/sports/lift/64/darts.webp', import.meta.url).href;
const artwork58_128 = new URL('../../assets/sports/lift/128/darts.webp', import.meta.url).href;
const artwork58_256 = new URL('../../assets/sports/lift/256/darts.webp', import.meta.url).href;
const artwork58_512 = new URL('../../assets/sports/lift/512/darts.webp', import.meta.url).href;
const artwork59_64 = new URL('../../assets/sports/lift/64/chess.webp', import.meta.url).href;
const artwork59_128 = new URL('../../assets/sports/lift/128/chess.webp', import.meta.url).href;
const artwork59_256 = new URL('../../assets/sports/lift/256/chess.webp', import.meta.url).href;
const artwork59_512 = new URL('../../assets/sports/lift/512/chess.webp', import.meta.url).href;
const artwork60_64 = new URL('../../assets/sports/lift/64/clay-shooting.webp', import.meta.url)
  .href;
const artwork60_128 = new URL('../../assets/sports/lift/128/clay-shooting.webp', import.meta.url)
  .href;
const artwork60_256 = new URL('../../assets/sports/lift/256/clay-shooting.webp', import.meta.url)
  .href;
const artwork60_512 = new URL('../../assets/sports/lift/512/clay-shooting.webp', import.meta.url)
  .href;
const artwork61_64 = new URL('../../assets/sports/lift/64/snowboard.webp', import.meta.url).href;
const artwork61_128 = new URL('../../assets/sports/lift/128/snowboard.webp', import.meta.url).href;
const artwork61_256 = new URL('../../assets/sports/lift/256/snowboard.webp', import.meta.url).href;
const artwork61_512 = new URL('../../assets/sports/lift/512/snowboard.webp', import.meta.url).href;
const artwork62_64 = new URL('../../assets/sports/lift/64/sailing.webp', import.meta.url).href;
const artwork62_128 = new URL('../../assets/sports/lift/128/sailing.webp', import.meta.url).href;
const artwork62_256 = new URL('../../assets/sports/lift/256/sailing.webp', import.meta.url).href;
const artwork62_512 = new URL('../../assets/sports/lift/512/sailing.webp', import.meta.url).href;
const artwork63_64 = new URL('../../assets/sports/lift/64/backgammon.webp', import.meta.url).href;
const artwork63_128 = new URL('../../assets/sports/lift/128/backgammon.webp', import.meta.url).href;
const artwork63_256 = new URL('../../assets/sports/lift/256/backgammon.webp', import.meta.url).href;
const artwork63_512 = new URL('../../assets/sports/lift/512/backgammon.webp', import.meta.url).href;
const artwork64_64 = new URL('../../assets/sports/lift/64/cards.webp', import.meta.url).href;
const artwork64_128 = new URL('../../assets/sports/lift/128/cards.webp', import.meta.url).href;
const artwork64_256 = new URL('../../assets/sports/lift/256/cards.webp', import.meta.url).href;
const artwork64_512 = new URL('../../assets/sports/lift/512/cards.webp', import.meta.url).href;

const resources0 = {
  64: artwork0_64,
  128: artwork0_128,
  256: artwork0_256,
  512: artwork0_512,
} as const;
const resources1 = {
  64: artwork1_64,
  128: artwork1_128,
  256: artwork1_256,
  512: artwork1_512,
} as const;
const resources2 = {
  64: artwork2_64,
  128: artwork2_128,
  256: artwork2_256,
  512: artwork2_512,
} as const;
const resources3 = {
  64: artwork3_64,
  128: artwork3_128,
  256: artwork3_256,
  512: artwork3_512,
} as const;
const resources4 = {
  64: artwork4_64,
  128: artwork4_128,
  256: artwork4_256,
  512: artwork4_512,
} as const;
const resources5 = {
  64: artwork5_64,
  128: artwork5_128,
  256: artwork5_256,
  512: artwork5_512,
} as const;
const resources6 = {
  64: artwork6_64,
  128: artwork6_128,
  256: artwork6_256,
  512: artwork6_512,
} as const;
const resources7 = {
  64: artwork7_64,
  128: artwork7_128,
  256: artwork7_256,
  512: artwork7_512,
} as const;
const resources8 = {
  64: artwork8_64,
  128: artwork8_128,
  256: artwork8_256,
  512: artwork8_512,
} as const;
const resources9 = {
  64: artwork9_64,
  128: artwork9_128,
  256: artwork9_256,
  512: artwork9_512,
} as const;
const resources10 = {
  64: artwork10_64,
  128: artwork10_128,
  256: artwork10_256,
  512: artwork10_512,
} as const;
const resources11 = {
  64: artwork11_64,
  128: artwork11_128,
  256: artwork11_256,
  512: artwork11_512,
} as const;
const resources12 = {
  64: artwork12_64,
  128: artwork12_128,
  256: artwork12_256,
  512: artwork12_512,
} as const;
const resources13 = {
  64: artwork13_64,
  128: artwork13_128,
  256: artwork13_256,
  512: artwork13_512,
} as const;
const resources14 = {
  64: artwork14_64,
  128: artwork14_128,
  256: artwork14_256,
  512: artwork14_512,
} as const;
const resources15 = {
  64: artwork15_64,
  128: artwork15_128,
  256: artwork15_256,
  512: artwork15_512,
} as const;
const resources16 = {
  64: artwork16_64,
  128: artwork16_128,
  256: artwork16_256,
  512: artwork16_512,
} as const;
const resources17 = {
  64: artwork17_64,
  128: artwork17_128,
  256: artwork17_256,
  512: artwork17_512,
} as const;
const resources18 = {
  64: artwork18_64,
  128: artwork18_128,
  256: artwork18_256,
  512: artwork18_512,
} as const;
const resources19 = {
  64: artwork19_64,
  128: artwork19_128,
  256: artwork19_256,
  512: artwork19_512,
} as const;
const resources20 = {
  64: artwork20_64,
  128: artwork20_128,
  256: artwork20_256,
  512: artwork20_512,
} as const;
const resources21 = {
  64: artwork21_64,
  128: artwork21_128,
  256: artwork21_256,
  512: artwork21_512,
} as const;
const resources22 = {
  64: artwork22_64,
  128: artwork22_128,
  256: artwork22_256,
  512: artwork22_512,
} as const;
const resources23 = {
  64: artwork23_64,
  128: artwork23_128,
  256: artwork23_256,
  512: artwork23_512,
} as const;
const resources24 = {
  64: artwork24_64,
  128: artwork24_128,
  256: artwork24_256,
  512: artwork24_512,
} as const;
const resources25 = {
  64: artwork25_64,
  128: artwork25_128,
  256: artwork25_256,
  512: artwork25_512,
} as const;
const resources26 = {
  64: artwork26_64,
  128: artwork26_128,
  256: artwork26_256,
  512: artwork26_512,
} as const;
const resources27 = {
  64: artwork27_64,
  128: artwork27_128,
  256: artwork27_256,
  512: artwork27_512,
} as const;
const resources28 = {
  64: artwork28_64,
  128: artwork28_128,
  256: artwork28_256,
  512: artwork28_512,
} as const;
const resources29 = {
  64: artwork29_64,
  128: artwork29_128,
  256: artwork29_256,
  512: artwork29_512,
} as const;
const resources30 = {
  64: artwork30_64,
  128: artwork30_128,
  256: artwork30_256,
  512: artwork30_512,
} as const;
const resources31 = {
  64: artwork31_64,
  128: artwork31_128,
  256: artwork31_256,
  512: artwork31_512,
} as const;
const resources32 = {
  64: artwork32_64,
  128: artwork32_128,
  256: artwork32_256,
  512: artwork32_512,
} as const;
const resources33 = {
  64: artwork33_64,
  128: artwork33_128,
  256: artwork33_256,
  512: artwork33_512,
} as const;
const resources34 = {
  64: artwork34_64,
  128: artwork34_128,
  256: artwork34_256,
  512: artwork34_512,
} as const;
const resources35 = {
  64: artwork35_64,
  128: artwork35_128,
  256: artwork35_256,
  512: artwork35_512,
} as const;
const resources36 = {
  64: artwork36_64,
  128: artwork36_128,
  256: artwork36_256,
  512: artwork36_512,
} as const;
const resources37 = {
  64: artwork37_64,
  128: artwork37_128,
  256: artwork37_256,
  512: artwork37_512,
} as const;
const resources38 = {
  64: artwork38_64,
  128: artwork38_128,
  256: artwork38_256,
  512: artwork38_512,
} as const;
const resources39 = {
  64: artwork39_64,
  128: artwork39_128,
  256: artwork39_256,
  512: artwork39_512,
} as const;
const resources40 = {
  64: artwork40_64,
  128: artwork40_128,
  256: artwork40_256,
  512: artwork40_512,
} as const;
const resources41 = {
  64: artwork41_64,
  128: artwork41_128,
  256: artwork41_256,
  512: artwork41_512,
} as const;
const resources42 = {
  64: artwork42_64,
  128: artwork42_128,
  256: artwork42_256,
  512: artwork42_512,
} as const;
const resources43 = {
  64: artwork43_64,
  128: artwork43_128,
  256: artwork43_256,
  512: artwork43_512,
} as const;
const resources44 = {
  64: artwork44_64,
  128: artwork44_128,
  256: artwork44_256,
  512: artwork44_512,
} as const;
const resources45 = {
  64: artwork45_64,
  128: artwork45_128,
  256: artwork45_256,
  512: artwork45_512,
} as const;
const resources46 = {
  64: artwork46_64,
  128: artwork46_128,
  256: artwork46_256,
  512: artwork46_512,
} as const;
const resources47 = {
  64: artwork47_64,
  128: artwork47_128,
  256: artwork47_256,
  512: artwork47_512,
} as const;
const resources48 = {
  64: artwork48_64,
  128: artwork48_128,
  256: artwork48_256,
  512: artwork48_512,
} as const;
const resources49 = {
  64: artwork49_64,
  128: artwork49_128,
  256: artwork49_256,
  512: artwork49_512,
} as const;
const resources50 = {
  64: artwork50_64,
  128: artwork50_128,
  256: artwork50_256,
  512: artwork50_512,
} as const;
const resources51 = {
  64: artwork51_64,
  128: artwork51_128,
  256: artwork51_256,
  512: artwork51_512,
} as const;
const resources52 = {
  64: artwork52_64,
  128: artwork52_128,
  256: artwork52_256,
  512: artwork52_512,
} as const;
const resources53 = {
  64: artwork53_64,
  128: artwork53_128,
  256: artwork53_256,
  512: artwork53_512,
} as const;
const resources54 = {
  64: artwork54_64,
  128: artwork54_128,
  256: artwork54_256,
  512: artwork54_512,
} as const;
const resources55 = {
  64: artwork55_64,
  128: artwork55_128,
  256: artwork55_256,
  512: artwork55_512,
} as const;
const resources56 = {
  64: artwork56_64,
  128: artwork56_128,
  256: artwork56_256,
  512: artwork56_512,
} as const;
const resources57 = {
  64: artwork57_64,
  128: artwork57_128,
  256: artwork57_256,
  512: artwork57_512,
} as const;
const resources58 = {
  64: artwork58_64,
  128: artwork58_128,
  256: artwork58_256,
  512: artwork58_512,
} as const;
const resources59 = {
  64: artwork59_64,
  128: artwork59_128,
  256: artwork59_256,
  512: artwork59_512,
} as const;
const resources60 = {
  64: artwork60_64,
  128: artwork60_128,
  256: artwork60_256,
  512: artwork60_512,
} as const;
const resources61 = {
  64: artwork61_64,
  128: artwork61_128,
  256: artwork61_256,
  512: artwork61_512,
} as const;
const resources62 = {
  64: artwork62_64,
  128: artwork62_128,
  256: artwork62_256,
  512: artwork62_512,
} as const;
const resources63 = {
  64: artwork63_64,
  128: artwork63_128,
  256: artwork63_256,
  512: artwork63_512,
} as const;
const resources64 = {
  64: artwork64_64,
  128: artwork64_128,
  256: artwork64_256,
  512: artwork64_512,
} as const;

export const SPORT_ARTWORK_ASSETS: Readonly<Record<string, SportArtworkResources>> = {
  padel: resources0,
  tennis: resources1,
  squash: resources2,
  badminton: resources3,
  pickleball: resources4,
  'table-tennis': resources5,
  'football-5': resources6,
  'football-7': resources6,
  'football-11': resources6,
  basketball: resources7,
  volleyball: resources8,
  handball: resources9,
  rugby: resources10,
  'water-polo': resources11,
  taekwondo: resources12,
  karate: resources13,
  judo: resources14,
  bjj: resources15,
  kickboxing: resources16,
  'muay-thai': resources17,
  boxing: resources18,
  mma: resources19,
  swimming: resources20,
  'jet-ski': resources21,
  kayak: resources22,
  gym: resources23,
  crossfit: resources24,
  yoga: resources25,
  pilates: resources26,
  dance: resources27,
  cycling: resources28,
  running: resources29,
  hiking: resources30,
  climbing: resources31,
  skiing: resources32,
  bowling: resources33,
  billiards: resources34,
  golf: resources35,
  equestrian: resources36,
  archery: resources37,
  shooting: resources38,
  futsal: resources39,
  motocross: resources40,
  paragliding: resources41,
  karting: resources42,
  paintball: resources43,
  airsoft: resources44,
  'scuba-diving': resources45,
  surfing: resources46,
  kitesurfing: resources47,
  windsurfing: resources48,
  wakeboarding: resources49,
  rafting: resources50,
  'horse-racing': resources51,
  gymnastics: resources52,
  fencing: resources53,
  'ice-skating': resources54,
  skateboarding: resources55,
  parkour: resources56,
  petanque: resources57,
  darts: resources58,
  chess: resources59,
  'clay-shooting': resources60,
  snowboard: resources61,
  sailing: resources62,
  backgammon: resources63,
  cards: resources64,
};
